module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/LopwnA/media/FC-9789948831358.jpg?1684515570800",
      "alt": "This image is the cover for the book !اِنْهَضْ"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("!اِنْهَضْ\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("ما هـو؟ ومَـنْ؟ وكيـف؟ ولمـاذا؟ *هدف \" اِنْهَـــضْ \" أن يعلِّم الإنسان الذي يريد أن  ينتقل بحياته من ظلمة الغَسَقِ إلى انفراجة بزوغ الفجر.  ذاك الذي يريد ولادةً جديدةً، ويتوق بحرقة لحياة تستحق بأن تعاش. *المستهدفون \" باِنْهَـــضْ\" الجميع لا أستثني أحداً من البشرية، نعم لا أستثني أحداً من حتمية الاستفادة من \" اِنْهَـــضْ \". *يستفاد من \" اِنْهَـــضْ\" فقط إذا تم تطبيق قواعده وإرشاداته بدقة، والعمل بجد على ترسيخ الإيمان بمحتواه. وهذه عملية تصاعدية لا تلقن ولا تمنح، وإنما تنبع من داخل الإنسان وبإرادته المحضة يتم اتباعها وبقرار حاسم. *تطبق مبادئ \" اِنْهَـــضْ \" لكي يتمكَّن الإنسان أن يكون سيداً على مصيره وراسماً لقدره، متملِّكاً على فكره ومسيطراً على عقله ضمن حدود حرية الإختيار. ويعيش بكل سلام وسعادة وحرية ورضى. اِنْهَـــضْ ببساطة كتاب يخاطب العقل لينعش الطفل المبدع الذي بداخل كل منا. ما القيمة المضافة من \" اِنْهَـــضْ\"؟ نجد في الكتاب إجابات على العديد من الأسئلة الوجودية بتحديد جريء وبانعكاس علمي لم يسبق في أي كتاب من قبل. مثل توقع كيف تكون نهاية عالمنا الحالي؟ وما هو الحال الذي تؤول إليه الروح بعد الموت الجسدي الدائم للإنسان؟ وكيف تفعل حالة العقل ليصبح الإنسان مفكراً؟ \" اِنْهَـــضْ إذا نويتَ هدفاً ضمنتهُ\".")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      ليث حجازين\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("ليث حجازين شاب من الطبقة العادية ولكنه طَمُوح في بلد يقبر الطُمُوح، ثابر ليفعل شيئاً ويغير واقعه ففشل كثيراً.  وصل للقاع وخسر كل شيء مهم تقريباً، ومع هذا لم يستسلم بل حاول وحاول مراراً وتكراراً، فكتب كتاب تحفيز يعبر فيه باختصار عن معركته في الحياة وشارك القارئ في بعض ما وصل إليه من أرض معرفة عذراء، عن معركة تغيير القدر ورفع جودة الحياة أتحدث.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0